import { CATALOG_GENDER } from '@/shared/catalogs/gender'
import { CATALOG_TERM_APPOINTMENTS } from '@/shared/catalogs/term-appointments'
import { CATALOG_TYPE_CLIENT } from '@/shared/catalogs/type-client'
import { PaymentMethodOptions } from '../catalogs/payment-method'
import {
  DEPARTAMENTO_ENUM_VALUES,
  MUNICIPIO_ENUM_VALUES,
  PAIS_ENUM_VALUES
} from '../catalogs/place-enum-values'
import { StructureTypeOptions } from '../catalogs/structure-type'
import { UnitTypeOptions } from '../catalogs/unit-type'
import type { VariableEnumValue } from './types'

/**
 * LOS DOMINIOS CERRADOS QUE EL PAQUETE NO PUEDE DECLARAR, y por qué no puede.
 *
 * El metadato canónico vive en `@idc-forms/schemas/variables/document/*` y ahí cada una de estas
 * variables lleva `optionsFromHost: true` — la marca que dice «el dominio existe, pero lo aporta
 * el adaptador». Esta tabla es la otra mitad de esa marca.
 *
 * ☠️ No es una excepción de conveniencia; es que copiar cualquiera de estas listas al paquete
 * fabricaría la SEGUNDA fuente de verdad que el ADR 0036 existe para matar:
 *
 * | lista | dueño de verdad |
 * |---|---|
 * | país / departamento / municipio | `countries.json` + `departments-gt.json` + `municipalities-gt.json` — **170 KB de geografía** del bundle de la web. Subirlos los metería enteros en el bundle de la API a cambio de nada |
 * | tipo de cliente / género / plazo del nombramiento | los catálogos que YA usan los formularios (`@/shared/catalogs/*`) |
 * | unidad / estructura / forma de pago | los const portables de `variables/catalogs/*`, que también pintan selectores y tablas |
 *
 * La regla, dicha entera: **el dominio que ya tiene dueño en el host se queda con su dueño**; el
 * que se declaraba inline —`titular.figura`— se mudó entero al paquete, porque no tenía ninguno.
 *
 * ⚠️ Las dos mitades están probadas por separado (`registry.spec.ts`): una key acá que el paquete
 * no marca es un huérfano, y una marca del paquete sin entrada acá deja el catálogo con un `enum`
 * sin opciones — que es el selector ofreciendo texto libre donde hay una lista.
 */
export const HOST_ENUM_VALUES: Record<string, VariableEnumValue[]> = {
  unidad: UnitTypeOptions,
  estructura: StructureTypeOptions,
  forma_pago_inmueble: PaymentMethodOptions,
  'lugar.pais': PAIS_ENUM_VALUES,
  'lugar.departamento': DEPARTAMENTO_ENUM_VALUES,
  'lugar.municipio': MUNICIPIO_ENUM_VALUES,
  'titular.tipo_cliente': CATALOG_TYPE_CLIENT,
  'titular.genero': CATALOG_GENDER,
  'titular.pais': PAIS_ENUM_VALUES,
  'titular.departamento': DEPARTAMENTO_ENUM_VALUES,
  'titular.tipo_plazo': CATALOG_TERM_APPOINTMENTS
}
